var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded-full  pb-1 pt-1 pl-2 pr-2 bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 border-2 tag-cell"},[_vm._v(" "+_vm._s(_vm.tagName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }